import React, { useEffect } from 'react';
import "./home.scss"

//-Components
import Hero from "../../Components/Hero/Hero"
import Work from "../../Components/Work/Work"
import BriefAbout from "../../Components/BriefAbout/BriefAbout"
import Contact from '../../Components/Contact/Contact';

export function Home() {
    //page title
    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        window.scrollTo(0, 0);
    });


    return <>
        <div className='noise-div'></div>
        <div className="homepage-wrapper"> 
            <Hero />
            <div className='main main-dark'></div>
            <BriefAbout />
            <Work display="4"/>
            <div className='fade-flag'></div>    
            <Contact />       
        </div>
        
    </>
}